import Vue from 'vue';
import { Component, Inject, Prop, Watch } from 'vue-property-decorator';

import { IToolItem } from '../../models/designer-tools.model';
import { DesignerStateProvider } from '../../designer.provider';
import { DesignerToolNames } from '../../designer.enum';

@Component({
  name: 'ed-designer-elements-tools-item',
})
export default class EdDesignerElementsToolsItem extends Vue {
  @Prop({ default: null }) readonly tool: IToolItem;

  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;
  
  get isDisabled(): boolean {
    const isToolDisabled = this.DesignerStateProvider.toolsDisabled.includes(this.tool.name);
    const elementListEmpty = this.DesignerStateProvider.elements.length === 0;
    const { elementSelected, isTextOnPreRender } = this.DesignerStateProvider;

    return isToolDisabled || elementListEmpty || !elementSelected || isTextOnPreRender;
  }

  executeAction() {
    this.DesignerStateProvider.executeAction({
      action: this.tool.action,
    });

    this.validateToolsDisabled();
  }

  validateToolsDisabled() {
    const { elementSelected, elements } = this.DesignerStateProvider;
    const i = elements.indexOf(elementSelected);

    const toolsDisabled = [];

    if (i === elements.length - 1) {
      toolsDisabled.push(DesignerToolNames.BringToFront);
      toolsDisabled.push(DesignerToolNames.BringForward);
    }

    if (i === 0) {
      toolsDisabled.push(DesignerToolNames.SendBackward);
      toolsDisabled.push(DesignerToolNames.SendToBack);
    }

    this.DesignerStateProvider.updateZPosition();
    this.DesignerStateProvider.toolsDisabled = toolsDisabled;
  }

  @Watch('DesignerStateProvider.elementSelected')
  onElementSelectedChanged() {
    this.validateToolsDisabled();
  }
}